import { render, staticRenderFns } from "./ColorLabel.vue?vue&type=template&id=37291cdb&"
import script from "./ColorLabel.vue?vue&type=script&lang=js&"
export * from "./ColorLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports